import { Heading } from '@kpa/kul';
import { FC, ReactNode } from 'react';
import PageInfo from '../../components/PageInfo/PageInfo';
import ContentArea from '../../ContentArea';
import { StandardsidaResponse } from '../../types/pages';
import { ContentResponse } from '../../types/shared';
import XhtmlText from '../../XhtmlText';
import styles from './Standardsida.module.css';

interface IStandardsidaProps {
  contentResponse: ContentResponse;
}

const Standardsida: FC<IStandardsidaProps> = ({
  contentResponse,
}): ReactNode => {
  const standardsida = contentResponse.content as StandardsidaResponse;

  return (
    <div className={styles.standardsida}>
      <PageInfo variant={standardsida.döljPubliceringsdatum ? 'breadcrumbs' : 'both'} contentResponse={contentResponse}></PageInfo>
      <header>
        {standardsida.rubrik && <Heading headingLevel={1}>{standardsida.rubrik}</Heading>}
      </header>
      {standardsida.textytan && <XhtmlText xhtmlResponse={standardsida.textytan} />}
      <div>
        {standardsida.blockytan && <ContentArea contentAreaResponse={standardsida.blockytan} />}
      </div>
    </div>
  );
};

export default Standardsida;
